import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "flexBasis", "flexGrow", "flexShrink", "footerContent", "headerContent", "maxHeight", "Overhang", "scrollDirection", "scrollElementRef", "data-scrolling-column"];
import styled from 'foundations-theming/utils';
import { ShareScrollElement } from './ShareScrollElement';
import { ScrollContainer } from '../ScrollContainer/ScrollContainer';
import { Box } from '../Box';
import { toPx } from '../../../utils/toPx';
import { BREAKPOINTS } from '../Grid/Grid.types';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledHeader = styled.header.withConfig({
  displayName: "ScrollingColumn__StyledHeader",
  componentId: "m21smx-0"
})([">:last-child{margin-bottom:0;}"]);
const StyledWrapper = styled.div.withConfig({
  displayName: "ScrollingColumn__StyledWrapper",
  componentId: "m21smx-1"
})(["display:flex;flex-direction:column;height:100%;min-height:0;max-height:", ";width:100%;&{@media only screen and (max-width:", "px){max-height:none;}}"], props => props.$maxHeight && toPx(props.$maxHeight), BREAKPOINTS.sm);
const InternalScrollingColumn = _ref => {
  let {
      children,
      flexBasis,
      flexGrow,
      flexShrink,
      footerContent,
      headerContent,
      maxHeight,
      Overhang,
      scrollDirection = 'vertical',
      scrollElementRef,
      'data-scrolling-column': dataScrollingColumn
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(Box, Object.assign({}, rest, {
    blockSize: "100%",
    basis: flexBasis,
    grow: flexGrow,
    shrink: flexShrink,
    "data-scrolling-column": dataScrollingColumn,
    children: /*#__PURE__*/_jsxs(StyledWrapper, {
      $maxHeight: maxHeight,
      children: [headerContent && /*#__PURE__*/_jsx(StyledHeader, {
        children: headerContent
      }), /*#__PURE__*/_jsx(ScrollContainer, {
        autoHeight: true,
        Overhang: Overhang,
        scrollDirection: scrollDirection,
        scrollElementRef: scrollElementRef,
        children: children
      }), footerContent && /*#__PURE__*/_jsx("footer", {
        children: footerContent
      })]
    })
  }));
};
export const ScrollingColumn = ShareScrollElement(InternalScrollingColumn);